import type { AreaForm } from "@/pages/areas/schemas/area.edit.form";
import type { Area, UpdateAreaBody } from "@/types/area";

const withoutEmpty = (names: Record<string, string>): Record<string, string> =>
  Object.fromEntries(
    Object.entries(names)
      .map(([k, v]) => [k, v.trim()] as const)
      .filter(([, v]) => v !== ""),
  );

const sameMap = (a: Record<string, string>, b: Record<string, string>) => {
  const ka = Object.keys(a);
  return ka.length === Object.keys(b).length && ka.every((k) => a[k] === b[k]);
};

/**
 * Only what changed, or `null` for nothing. `displayNames` goes whole (the server replaces the
 * map) with empty values dropped; `keepOldNameAsAlias` only travels with a changed name.
 */
export const buildAreaPatch = (
  stored: Area,
  form: AreaForm,
): UpdateAreaBody | null => {
  const patch: UpdateAreaBody = {};
  const name = form.name.trim();
  if (name !== stored.name) {
    patch.name = name;
    patch.keepOldNameAsAlias = form.keepOldNameAsAlias;
  }
  if (
    form.parentId !== undefined &&
    form.parentId !== (stored.parentId ?? "")
  ) {
    patch.parentId = form.parentId;
  }
  if (form.partOrder !== undefined && form.partOrder !== stored.partOrder) {
    patch.partOrder = form.partOrder;
  }
  const names = withoutEmpty(form.displayNames);
  if (!sameMap(names, withoutEmpty(stored.displayNames ?? {}))) {
    patch.displayNames = names;
  }
  return Object.keys(patch).length ? patch : null;
};
